import React from 'react'

import {Trans, useTranslation} from '@modifi/plugin-i18n'

type TranslatedStringProps = {
  i18nKey: string
  values?: Record<string, string | number>
}

const TranslatedString: React.FC<TranslatedStringProps> = ({i18nKey, values}) => {
  const {t} = useTranslation('charon')
  return <Trans i18nKey={i18nKey} t={t} values={values} />
}

export default TranslatedString
